import { INiche } from "services/types";

export const getFilteredNiches = (niches: INiche[], selected: string[]) => {
  const part1 = niches.filter(x => selected.indexOf(x.id) >= 0);
  const part2 = niches.filter(x => selected.indexOf(x.id) < 0);
  return [...part1, ...part2];
};

export const updateSelectedNiches = (id: string, selected: string[]) => {
  let values;

  if (selected.indexOf(id) >= 0) {
    values = selected.filter(x => x !== id);
  } else {
    values = [...selected, id];
  }

  return values;
};
